import { Box, Button, Chip, FormControl, Grid, InputLabel, List, ListItem, MenuItem, Paper, Select, SelectChangeEvent, TextField } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { Configuration, Device , DeviceApi, DeviceTypeEnum} from "../../generated/workplace";
import { useAuth } from "oidc-react";
import { useSnackbar } from "../../utils/snackbar";


// Inspired from https://github.com/microsoft/TypeScript/issues/30611#issuecomment-570773496
function getEnumKeys<T extends string, TEnumValue extends string | number,>(enumVariable: { [key in T]: TEnumValue }) {
    const keys = Object.keys(enumVariable);
    
    const filtered = keys.filter((key) => {
        return key !== "UnknownDefaultOpenApi";
    });
    
    return filtered as Array<T>;
}

interface ICreateDeviceProps {
    registerSubmit? : (fn: () => Promise<string | null | undefined>) => void;
}

const CreateDevice = (props:ICreateDeviceProps) => {

    const [device, setDevice] = useState<Device>({});
    
    const [tempTag, setTempTag] = useState<string>("");

    const showSnackbar = useSnackbar();


    // const [id, setId] = useState<string>("");

    // const [tags, setTags] = React.useState<readonly string[]>([
    //     // "left",
    //     // "right"
    // ]);

    const auth = useAuth();

    const access_token = auth.userData?.access_token;

    const createNewDevice = async () => {

        const deviceApi = new DeviceApi(new Configuration({'accessToken': access_token!}));

        let result:Device|null = null;
        try {
            result = await deviceApi.postDevice({device: device});
            
        } catch (error) {
            console.log("error postDevice", error);

            showSnackbar(`Device ${device.id} konnte nicht angelegt werden`, "error");
                
        }

        if(result){

            showSnackbar(`Device ${result.id} angelegt`, "success");
            return result.id;
        }
        
        // dummy debug
        return device.id;

        return null;
    }

    const createNewDeviceCallback = useCallback(createNewDevice, [access_token, device]);


    const { registerSubmit } = props;

    useEffect(() => {
        if(registerSubmit){
            registerSubmit(createNewDeviceCallback)
        }
    }, [createNewDeviceCallback, registerSubmit]);


    const handleDeleteTag = (chipToDelete: string) => () => {
        // setTags((chips) => chips.filter((chip) => chip !== chipToDelete));

        setDevice((oldDevice) => {
            return {
                ...oldDevice,
                tags: oldDevice.tags?.filter((chip) => chip !== chipToDelete)
            }
        });
    };

    const handleAddTag = (tag:string) => {
        if(tag != null && tag.length > 0 && (device.tags ?? [] ).indexOf(tag) === -1){
            // setTags((chips) => {
            //     const newChips = [...chips];
            //     newChips.push(tag);

            //     return newChips;
            // });

            setDevice((oldDevice) => {
                const newTags = [...oldDevice.tags ?? []];
                newTags.push(tag);

                return {
                    ...oldDevice,
                    tags: newTags
                }
            });

            setTempTag("");
        }
    }
    

    return (
        <div>
            CreateDevice
            
            <Grid container spacing={2} paddingTop={2}>

                <Grid item xs={12}>
                    <Box>
                        <TextField 
                            name="id" 
                            label="ID" 
                            variant="outlined" 
                            onChange={(event) => {
                                const value = event.target.value;

                                // setId(value);

                                setDevice((oldDevice) => {
                                    return {
                                        ...oldDevice,
                                        id: value
                                    }
                                });
                            }}

                            fullWidth
                            value={device.id}
                        />
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    <Box>
                        <FormControl fullWidth>
                            <InputLabel id="type-label">Type</InputLabel>

                            <Select 
                                value={device.type ?? ""}
                                fullWidth
                                labelId="type-label"
                                label="Type"

                                onChange={(event: SelectChangeEvent) => {
                                    const value = event.target.value;
                                    
                                    setDevice((oldDevice) => {
                                        return {
                                            ...oldDevice,
                                            type: value as DeviceTypeEnum
                                        }
                                    });
                                }}
                            >
                                {getEnumKeys(DeviceTypeEnum).map((key, index) => (
                                    <MenuItem key={index} value={DeviceTypeEnum[key]}>
                                        {key}
                                    </MenuItem>
                                    
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    <Box>
                        
                        <Paper
                            sx={{
                                p: 0.5,
                                m: 0,
                            }}
                        >
                            <List
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'left',
                                    flexWrap: 'wrap',
                                    listStyle: 'none',
                                    p: 0.5,
                                    m: 0,
                                    '& .MuiListItem-root': {
                                        width: "auto"
                                    }
                                }}
                            >
                                {device.tags?.map((data) => {
                                    let icon;


                                    return (
                                        <ListItem key={data}>
                                            <Chip
                                                icon={icon}
                                                label={data}
                                                onDelete={handleDeleteTag(data)}
                                            />
                                        </ListItem>
                                    );
                                })}

                            </List>
                        
                            <Grid container paddingTop={2}>
                                <Grid item xs={8} sm={10}>
                                    <TextField 
                                        name="tag" 
                                        label="Tag" 
                                        variant="outlined" 
                                        onChange={(event) => {
                                            const value = event.target.value;

                                            setTempTag(value);
                                        }}

                                        fullWidth

                                        value={tempTag}
                                        
                                    />
                                
                                </Grid>

                                <Grid item xs={4} sm={2}>
                                    <Button 
                                        color="primary"
                                        variant="outlined"
                                        sx={
                                            {
                                                height: "100%"
                                            }
                                        }
                                        fullWidth
                                        
                                        onClick={() => {
                                            handleAddTag(tempTag);
                                        }}
                                    >Add Tag</Button>
                                </Grid>

                            </Grid>
                        </Paper>

                    </Box>
                </Grid>
            </Grid>



        </div>
    )
};

export default CreateDevice;
